// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__18ABo","requiredAsterisk":"Info_requiredAsterisk__18Q0m"};